import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20fe5210"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "value", "name", "placeholder", "required", "autofocus"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VRuntimeTemplate = _resolveComponent("VRuntimeTemplate")!
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("textarea", {
      id: _ctx.id,
      value: _ctx.value,
      name: _ctx.name,
      placeholder: _ctx.placeholder,
      required: _ctx.required,
      style: _normalizeStyle(`${_ctx.noResize ? 'resize: none;' : ''}`),
      class: _normalizeClass(["autoFocus tw-flex tw-w-full tw-items-start tw-gap-2.5 tw-border tw-text-[#231F20] tw-text-[13px] tw-px-5 tw-pt-[17.5px] tw-pb-[17px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1]", `${_ctx.className} ${_ctx.validation?.$error ? 'error' : ''}`]),
      autofocus: !_ctx.value ? true : false,
      onBlur: _cache[0] || (_cache[0] = 
      () => {
        _ctx.validateOnBlur && _ctx.validation?.$touch && _ctx.validation.$touch();
        _ctx.$emit('blur');
      }
    ),
      onFocusout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('focusout'))),
      onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('focus'))),
      onInput: _cache[3] || (_cache[3] = (e) => _ctx.$emit('update:value', e.target.value))
    }, null, 46, _hoisted_1),
    _createVNode(_component_b_form_invalid_feedback, {
      class: _normalizeClass({ 'is-invalid': _ctx.validation.$error })
    }, {
      default: _withCtx(() => [
        _createVNode(_component_VRuntimeTemplate, {
          template: _ctx.validation?.$errors?.[0]?.$message
        }, null, 8, ["template"])
      ]),
      _: 1
    }, 8, ["class"])
  ], 64))
}